import { BaseItem } from '../common';
import { Kind as RpaJobKind } from '../rpaJob';
import * as Entity from './entity';

export { Entity };

export interface CreateValues {
  name: string;
  organizationId: string;
  jobsToRun: RpaJobKind[];
  feedIds: string[];
  encounterIds: string[];
  ehrInformationIds: string[];
  patientOrderIds: string[];
}

export type UpdateValues = Partial<CreateValues> & {
  id: string;
  stopped?: boolean;
};

export interface FindAllOptions {
  organizationId?: string;
  userId?: string;
  stopped?: boolean;
}

export interface WorkflowTest extends BaseItem {
  name: string;
  organizationId: string;
  userId: string;
  stopped: boolean;
}

export interface WorkflowTestPopulated
  extends WorkflowTest,
    EntityIdsWithPatientNames {
  jobsToRun: RpaJobKind[];
  feedIds: string[];
}

export interface EntityIdsWithPatientNames {
  ehrInformation: EntityIdWithPatientName[];
  encounters: EntityIdWithPatientName[];
  patientOrders: EntityIdWithPatientName[];
}

export interface EntityIdWithPatientName {
  id: string;
  firstName: string;
  lastName: string;
}
